export enum HighestVehicleRoleStatus {
    Sponsor,
    Liable,
    PendingLiable,
    NoLiable
}
